import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l14 0","key":"svg-0"}],["path",{"d":"M5 12l4 4","key":"svg-1"}],["path",{"d":"M5 12l4 -4","key":"svg-2"}]]

const IconArrowNarrowLeft = createReactComponent('outline', 'arrow-narrow-left', 'ArrowNarrowLeft', __iconNode);

export default IconArrowNarrowLeft;